import React from 'react';
import { Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useHistory, useLocation, Link } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import "./Login.css";

const Login = () => {
    const { accessWithGoogle, loginWithMail, isAdmin, loginError, googleLoginError } = useAuth();
    const location = useLocation();
    const history = useHistory();
    let redirected_uri = location.state?.from || '/collections';
    
    if (isAdmin) {
        redirected_uri = '';
    }

    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = data => {
        const { email, password } = data;

        loginWithMail(email, password, history, redirected_uri);
    };

    const handleAccessWithGoogle = () => {
        accessWithGoogle(history, redirected_uri, 'login');
    }
    
    return (
        <div>
            <div className="page-login">
                <div style={{background:"rgba(0,0,0,0.77)", height: "100vh"}} className="">
                    <div style={{width: '100%'}} className="row">
                        <div style={{maxWidth: '400px', minWidth: '250px', background: "rgba(255, 255, 255, 0.5)"}} className="py-4 px-5 shadow-lg rounded col-md-6 col-12" >
                            <form className="form-sizing d-flex custom-form flex-column" onSubmit={handleSubmit(onSubmit)}>
                                {/* <h3 className="text-center">ChothaOn</h3> */}
                                <h4 className="text-center mb-4 mt-2">Login</h4>

                                <label style={{fontWeight: "500"}}>Enter Email</label>
                                <input className="px-2 mt-3 mb-4" placeholder="example@provider.com" type="email" {...register("email", { required: true })} />
                                {errors.email && <span className="mb-2 text-danger">Something's not correct</span>}

                                <label style={{fontWeight: "500"}}>Enter Passsword</label>
                                <input className="px-2 mt-3" placeholder="Drop your password :D" type="password" {...register("password", { required: true })} />
                                {errors.password && <span className="mb-2 text-danger">Something's not correct</span>}

                                {
                                    loginError &&
                                    <p className="text-danger text-center">[ {loginError.split('/')[1].split('-').join(' ')[0].toUpperCase()+loginError.split('/')[1].split('-').join(' ').substring(1)} ]</p>    
                                }

                                {
                                    googleLoginError &&
                                    <p className="text-danger text-center">[ {googleLoginError.split('/')[1].split('-').join(' ')[0].toUpperCase()+googleLoginError.split('/')[1].split('-').join(' ').substring(1)} ]</p>    
                                }
                        

                                <div className="mx-auto"><input className="my-3 px-2 btn-custom" type="submit" value="Login" /></div>

                                <div>
                                <p className="border-top text-center pt-2">Or, Sign In With Google</p>
                                <div className="d-flex justify-content-center">
                                    <Button type="button" variant="dark" onClick={handleAccessWithGoogle} className="px-2 py-1 google-hover google-logo"><i className="fa-brands fa-google" /></Button>
                                </div>
                                <div className="mt-4 mb-2 text-center">
                                    <p>New Here? <Link to="/register">Register</Link></p>
                                </div>
                            </div>

                            </form>

                        </div>
                        <div style={{minHeight: "100vh"}} className="col-md-6 col-12 text-light d-flex flex-column justify-content-center align-items-center">
                            <p className="text-uppercase mb-0 pb-3">Are you a <span className="ruet">RUETIAN?</span></p>
                            <h2 className="text-center mt-0">Welcome to <span className="brand">ChothaOn</span></h2>
                            <p className="pt-4 mt-3 mb-0 pb-3">Cannot find any resource (AKA Chotha)?</p>
                            <p className="text-center">We're here for you</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login;